/**
 *
 * @param options
 */
export function validInputStyle({
  type,
  input,
  container,
  feedBack,
  message
}: OptionsValidInputStyle) {
  const VALIDATIONS: Validations = {
    /**
     *
     */
    valid() {
      container.classList.add('has-success');
      container.classList.remove('has-danger');

      input.classList.add('is-valid');
      input.classList.remove('is-invalid');

      if (feedBack) {
        feedBack.classList.add('valid-feedback');
        feedBack.classList.remove('invalid-feedback');
        feedBack.innerText = message!;
      }
    },
    /**
     *
     */
    invalid() {
      container.classList.add('has-danger');
      container.classList.remove('has-success');

      input.classList.add('is-invalid');
      input.classList.remove('is-valid');

      if (feedBack) {
        feedBack.classList.add('invalid-feedback');
        feedBack.classList.remove('valid-feedback');
        feedBack.innerText = message!;
      }
    },
    /**
     *
     */
    reset() {
      container.classList.remove('has-success', 'has-danger');
      input.classList.remove('is-valid', 'is-invalid');
      if (feedBack) {
        feedBack.classList.remove('valid-feedback', 'invalid-feedback');
        feedBack.innerText = '';
      }
    }
  };

  VALIDATIONS[type]();
}

/**
 *
 * @param e
 * @returns
 */
export function validationInputs({
  e,
  target,
  error
}: OptionsValidationInputs) {
  // Optencion de los elementos del input
  const input = e ? (e.target as CustomInputElement) : target!;
  const container = input.parentElement as HTMLDivElement;

  // Se valida que el input este basio
  const isEmty = input.value.length <= 0;
  if (isEmty) {
    return error
      ? validInputStyle({
          type: ValidationsTypes.INVALID,
          container,
          input
        })
      : validInputStyle({
          type: ValidationsTypes.RESET,
          container,
          input
        });
  }

  return validInputStyle({
    type: ValidationsTypes.VALID,
    container,
    input
  });
}

// Definición de tipos e interfaces
type CustomInputElement = HTMLInputElement | HTMLSelectElement;
type OptionsValidationInputs = {
  e?: Event;
  target?: CustomInputElement;
  error?: boolean;
};
export type OptionsValidInputStyle = {
  type: ValidationsTypes;
  input: HTMLInputElement | HTMLSelectElement;
  container: HTMLDivElement;
  feedBack?: HTMLSpanElement;
  message?: string;
};
export enum ValidationsTypes {
  VALID = 'valid',
  INVALID = 'invalid',
  RESET = 'reset',
}
export type Validations = {
  valid: () => void;
  invalid: () => void;
  reset: () => void;
};
